const GROUP_SESSION_URL_PREFIX = "/group-video-chat?code=";

export default GROUP_SESSION_URL_PREFIX;
